import React from 'react';
import LeadershipChrome from '@/components/LeadershipChrome';
import { LEADERSHIP_CONTENT } from '@/config/leadershipLayout';
import usePatientCapabilities from '@/modules/patient-portal/hooks/usePatientCapabilities';
import { patientMenuItems } from '@/modules/patient-portal/utils/patientMenuItems';

/** Patient portal — IITH campus chrome; menu gated by faculty/staff. */
export default function PatientPortalShell({ children, wide = false }) {
  const { isFacultyStaff, loading } = usePatientCapabilities();
  const menuItems = loading ? [] : patientMenuItems(isFacultyStaff);

  return (
    <LeadershipChrome
      homeHref="/patient"
      roleLabel="Patient portal"
      menuItems={menuItems}
    >
      <div className={`${LEADERSHIP_CONTENT} ${wide ? '' : 'max-w-5xl'}`}>
        {children}
      </div>
    </LeadershipChrome>
  );
}
